
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Punetomumbaiurbaniaonrent() {



    const cardData =
    {
        keyword: '  Pune to Mumbai Urbania On Rent',
        heading: 'Samarth Travels: Pune to Mumbai Urbania On Rent',
        headingDescription: 'Samarth Travels offers Urbania on rent from Pune to Mumbai, ideal for business trips, airport transfers, family outings, and group travel. Our high-end Force Urbania vehicles come with air-conditioning, push-back seats, and spacious interiors to make your intercity journey smooth and relaxing. With professional drivers, transparent fares, and reliable service, Samarth Travels ensures a safe and comfortable Pune to Mumbai travel experience.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

       "topPlaces": [
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892 by Sultan Aga Khan III, this sprawling palace is an architectural gem and a key monument in India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The palace features Italian arches, sprawling gardens, and houses a museum that contains personal belongings of Gandhi and historical photographs. It is also the final resting place of Kasturba Gandhi and Mahadev Desai, adding to its solemn importance."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located about 30 kilometers from Pune, Sinhagad Fort sits atop the Sahyadri mountains and is a favorite trekking destination for locals and tourists alike. With a history dating back over a thousand years, the fort was famously the site of the battle between the Marathas and the Mughals in 1670. Visitors are drawn to its rugged beauty, crumbling fortifications, and sweeping views of the surrounding valleys, especially during monsoons when the hills are lush green and covered in mist."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "This 8th-century rock-cut temple is carved entirely from a single basalt rock and dedicated to Lord Shiva. Nestled quietly amidst urban Pune, Pataleshwar offers a striking contrast to the city’s bustle. It features a circular Nandi Mandapa and intricately carved columns and sanctums. A protected monument under the Archaeological Survey of India, it’s a peaceful retreat and an excellent example of early Indian rock architecture."
    },
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a majestic 18th-century fortification located in the heart of Pune. Once the seat of the powerful Peshwas of the Maratha Empire, it is renowned for its historical significance, massive gateways, and intriguing legends, including ghost stories tied to its mysterious past. Despite being partially destroyed by fire, the remaining structures, especially the Delhi Gate and the fort’s expansive garden layout, provide a fascinating glimpse into Maratha architecture and political history."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "One of the most famous Ganesh temples in India, Dagdusheth Halwai Ganpati Temple attracts millions of devotees every year, especially during Ganesh Chaturthi. The temple’s grand idol of Lord Ganesh is adorned with gold and jewelry, symbolizing prosperity and devotion. Built by a sweetmaker in the 1800s, the temple also engages in numerous social and cultural initiatives, making it both a religious and community hub."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "Founded by Dr. Dinkar Kelkar in memory of his son, this museum is a treasure trove of Indian heritage. It houses over 20,000 artifacts, including musical instruments, ancient utensils, sculptures, paintings, and even quirky items like betel nut crackers and door frames. The collection offers insight into the daily lives and traditions of Indians across centuries, and its carefully curated exhibits make it a cultural landmark in Pune."
    },
    {
      "title": "Parvati Hill and Temple",
      "description": "Parvati Hill is one of Pune’s oldest heritage sites and offers a combination of spiritual serenity and scenic views. Climbing 103 steps leads to a temple complex dedicated to Goddess Parvati and Lord Shiva. The hill also hosts a small museum, Peshwa-era relics, and panoramic views of the cityscape below, making it ideal for morning walks and peaceful contemplation."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in the serene and green Koregaon Park area, the Osho International Meditation Resort is a global center for spiritual seekers. It offers dynamic meditation sessions, wellness therapies, and luxurious facilities in a Zen-like atmosphere. Known for attracting international visitors, the ashram promotes mindfulness, inner peace, and holistic living through Osho’s teachings."
    },
    {
      "title": "Pune Okayama Friendship Garden",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped space—also known as Pu La Deshpande Garden—is perfect for nature lovers and photographers. The garden features flowing streams, lush lawns, bridges, and seasonal flowers, offering a tranquil escape right in the city. It’s ideal for evening walks and peaceful getaways."
    },
    {
      "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
      "description": "Spread over 130 acres, this complex features a zoo, snake park, and animal rescue center. The snake park houses over 160 species of snakes, including cobras and pythons, while the zoo includes tigers, leopards, elephants, and more. Educational exhibits make it an informative and fun spot for children and families, combining entertainment with awareness about wildlife conservation."
    }
  ],

"services": [
    {
        "name": "Urbania Bus On Rent in Mumbai Airport",
        "description": "Samarth Travels offers Urbania bus rental services at Mumbai Airport for pickups and drop-offs. Ideal for group arrivals or departures, our Urbania buses provide air-conditioned comfort, luggage space, and on-time service. Whether you're heading to Pune, a hotel, or a corporate venue, we ensure a smooth transition from airport to destination."
    },
    {
        "name": "Pune to Mumbai Airport Urbania on Rent",
        "description": "Travel from Pune to Mumbai Airport in comfort with our Urbania rental service. Designed for both individual and group travel, our vehicles ensure timely airport arrivals with ample space for passengers and luggage. Our trained drivers follow the best routes to avoid delays, providing a stress-free experience for early morning or late-night flights."
    },
    {
        "name": "Mumbai Airport to Pune Urbania on Rent",
        "description": "Arriving at Mumbai Airport and heading to Pune? Book our Urbania rental for a comfortable, non-stop journey. Our drivers track your flight for punctual pickups and offer a relaxing ride to Pune with amenities like air-conditioning, reclining seats, and plenty of luggage space—ideal for families, corporate teams, or tourists."
    },
    {
        "name": "Force Urbania on Rent in Mumbai",
        "description": "Samarth Travels provides Force Urbania rental in Mumbai for a range of needs including corporate transfers, airport pickups, family outings, and outstation trips. Our fleet is maintained for reliability and equipped with modern features to ensure a premium group travel experience in the city or beyond."
    },
    {
        "name": "Luxury Force Urbania on Rent in Pune",
        "description": "Experience high-end group travel with our luxury Force Urbania on rent in Pune. These vans feature plush seating, individual AC vents, premium interiors, and infotainment systems. Perfect for weddings, executive transport, or special occasions, our luxury Urbania ensures you travel in comfort and style."
    },
    {
        "name": "13 Seater Urbania on Rent in Pimpri Chinchwad",
        "description": "Looking for a 13-seater vehicle in Pimpri Chinchwad? Our Urbania vans are perfect for small groups, office teams, or families needing reliable transportation. Enjoy features like AC, cushioned seats, and professional drivers for local or outstation use—all at competitive pricing."
    },
    {
        "name": "17 Seater Urbania on Rent in Pimpri Chinchwad",
        "description": "Need extra seating? Samarth Travels offers 17-seater Urbania vans in Pimpri Chinchwad for large families, school groups, or corporate travel. The vehicle provides ample room for passengers and luggage, ensuring a relaxed experience whether you're traveling within the city or outstation."
    },
    {
        "name": "13 Seater Urbania on Rent in Pune",
        "description": "Samarth Travels provides 13-seater Urbania rentals in Pune, ideal for small group travel, religious tours, and team outings. With spacious seating and safety features, our vans are suited for all-day journeys and outstation trips. Book your ride today for a dependable and cozy experience."
    },
    {
        "name": "17 Seater Urbania on Rent in Pune",
        "description": "Travel with larger groups easily with our 17-seater Urbania rental in Pune. Whether it's a school trip, business tour, or family function, this vehicle offers a reliable solution with comfortable interiors, large windows, AC, and an experienced driver to ensure safe and enjoyable travel."
    },
    {
        "name": "Urbania Bus on Rent for Corporate Employees",
        "description": "Samarth Travels provides Urbania bus rental for corporate employee transportation in Pune and nearby regions. Whether it's daily office commutes, team transfers, or offsite events, our service ensures punctuality, comfort, and professional handling of logistics for your business."
    },
    {
        "name": "Pune to Mumbai Urbania Bus on Rent",
        "description": "Our Pune to Mumbai Urbania bus rental service is perfect for group travel between cities. Enjoy a comfortable journey with reclining seats, air-conditioning, and a trained driver. Ideal for business trips, airport transfers, and family vacations requiring safe and smooth intercity travel."
    },
    {
        "name": "Force Urbania Luxury Mini Bus on Rent",
        "description": "Rent a luxury Force Urbania mini bus with Samarth Travels for your next event or outstation tour. With upgraded interiors, smooth suspension, and all modern comforts, this premium mini bus is suited for executives, VIP guests, and high-end events."
    },
    {
        "name": "Force Urbania 17 Seater for Rent",
        "description": "Samarth Travels offers a spacious and comfortable 17-seater Force Urbania for rent in Pune. Ideal for large families, student groups, or corporate teams, this vehicle is equipped with all essential amenities to make long trips or short tours comfortable and efficient."
    },
    {
        "name": "Force Urbania for Rent Near Me",
        "description": "Looking for 'Force Urbania for rent near me'? Samarth Travels serves multiple locations across Pune, Pimpri Chinchwad, and Mumbai. Our Urbania vans are available with flexible timing, professional drivers, and well-maintained interiors to make your travel reliable and convenient."
    },
    {
        "name": "Force Urbania Luxury Mini Bus on Rent in Pune",
        "description": "Upgrade your group travel with our luxury Force Urbania mini bus rentals in Pune. This vehicle is ideal for weddings, VIP guests, or executive tours and comes loaded with comfortable seating, ambient lighting, and air-conditioning. Samarth Travels ensures a top-notch travel experience for every client."
    },
    {
        "name": "Pune to Mumbai Airport Urbania Bus on Rent",
        "description": "Need reliable group transport from Pune to Mumbai Airport? Book our Urbania bus for a relaxed ride with professional service. With airport-optimized pickup and drop solutions, we ensure you reach your flight on time, without stress. Spacious interiors and courteous drivers make the ride smooth and efficient."
    },
    {
        "name": "Urbania on Rent in Pimpri Chinchwad",
        "description": "Samarth Travels offers Urbania on rent in Pimpri Chinchwad for local, outstation, and corporate travel needs. Whether you need a vehicle for a family event, city tour, or employee transport, our well-maintained fleet and skilled drivers are ready to serve you with professionalism and punctuality."
    }
],
"tableData": [
    ["Urbania Bus On Rent in Mumbai Airport", "Pune to Mumbai Airport Urbania on Rent"],
    ["Mumbai Airport to Pune Urbania on Rent", "Force Urbania on Rent in Mumbai"],
    ["Luxury Force Urbania on Rent in Pune", "13 Seater Urbania on Rent in Pimpri Chinchwad"],
    ["17 Seater Urbania on Rent in Pimpri Chinchwad", "13 Seater Urbania on Rent in Pune"],
    ["17 Seater Urbania on Rent in Pune", "Urbania Bus on Rent for Corporate Employees"],
    ["Pune to Mumbai Urbania Bus on Rent", "Force Urbania Luxury Mini Bus on Rent"],
    ["Force Urbania 17 Seater for Rent", "Force Urbania for Rent Near Me"],
    ["Force Urbania Luxury Mini Bus on Rent in Pune", "Pune to Mumbai Airport Urbania Bus on Rent"],
    ["Urbania on Rent in Pimpri Chinchwad", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Force Urbania Rental Service for Pune to Mumbai",
        "WhyChoosedescription": "We offer trustworthy Force Urbania van rental services for your travel between Pune and Mumbai. Whether it’s for business, family outings, or group trips, we ensure a comfortable, timely, and hassle-free journey, with professional drivers and well-maintained vehicles."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Force Urbania Vans for Long-Distance Travel",
        "WhyChoosedescription": "Our Force Urbania vans are perfect for long trips like Pune to Mumbai. With seating options ranging from 9 to 17 passengers, each van is equipped with air-conditioning, ample legroom, reclining seats, and charging ports, ensuring comfort during the entire journey."
    },
    {
        "WhyChooseheading": "Professional Drivers for Safe and Punctual Travel",
        "WhyChoosedescription": "Our skilled drivers are experienced with the Pune to Mumbai route and prioritize your safety and comfort. They ensure timely arrivals, smooth navigation through busy highways, and provide a safe travel experience for all passengers."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Pune to Mumbai Rentals",
        "WhyChoosedescription": "We offer competitive and transparent pricing with no hidden charges for your Pune to Mumbai trip. Whether you need a van for a few hours or an entire day, we provide flexible packages that ensure you receive great value for money."
    },
    {
        "WhyChooseheading": "24/7 Availability to Match Your Travel Schedule",
        "WhyChoosedescription": "Our Force Urbania rental services are available 24/7, allowing you to schedule your journey from Pune to Mumbai whenever it suits you best. Whether it's an early morning departure or a late-night return, we are here to meet your travel needs."
    },
    {
        "WhyChooseheading": "Effortless Booking and Real-Time Updates for Your Peace of Mind",
        "WhyChoosedescription": "Booking your Force Urbania rental for Pune to Mumbai is simple and quick. Once confirmed, you’ll receive real-time tracking information, driver contact details, and updates on your van’s arrival, helping you stay informed throughout the journey."
    },
    {
        "WhyChooseheading": "Well-Maintained, Clean, and Sanitized Urbania Vans",
        "WhyChoosedescription": "We ensure that each of our Force Urbania vans is well-maintained, thoroughly cleaned, and sanitized before every trip. This attention to hygiene and vehicle upkeep guarantees a safe and comfortable experience for your entire group."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Convenient Booking",
        "WhyChoosedescription": "We offer a range of payment methods for your convenience, including UPI, credit/debit cards, digital wallets, and cash, allowing you to securely and easily complete your booking process."
    }
]






















    }

const faqData = [
    {
        id: 1,
        question: 'How can I rent a Force Urbania for a Pune to Mumbai trip with Samarth Travels?',
        answer: 'Booking a Force Urbania for your Pune to Mumbai trip is easy. Simply contact Samarth Travels via our website or by phone. Share your travel details, including your preferred date, number of passengers, and pickup location, and we will handle the rest.',
    },
    {
        id: 2,
        question: 'What is the fare for a Pune to Mumbai Urbania rental?',
        answer: 'The fare for a Pune to Mumbai Urbania trip typically starts from ₹9,000 to ₹12,000, depending on the seating capacity (13 or 17-seater) and duration. This includes the vehicle, driver, and fuel for a fixed km limit, with extra charges for tolls or taxes.',
    },
    {
        id: 3,
        question: 'Is the Force Urbania suitable for long-distance travel like Pune to Mumbai?',
        answer: 'Yes, the Force Urbania is perfectly suited for long-distance travel. It offers reclining seats, air conditioning, ample luggage space, and modern amenities, ensuring a comfortable journey from Pune to Mumbai.',
    },
    {
        id: 4,
        question: 'How long does it take to travel from Pune to Mumbai in an Urbania?',
        answer: 'The distance from Pune to Mumbai is approximately 150 km, and the journey usually takes around 3 to 4 hours, depending on traffic. Our experienced drivers ensure a smooth and safe ride through the expressway.',
    },
    {
        id: 5,
        question: 'Can I include stops or sightseeing on my Pune to Mumbai trip?',
        answer: 'Yes, Samarth Travels offers customized travel options. You can include stops for sightseeing or meals along the way. Just inform us in advance so we can plan your journey accordingly.',
    },
    {
        id: 6,
        question: 'Is the Urbania available for a one-way trip from Pune to Mumbai?',
        answer: 'Yes, we offer one-way rentals for the Pune to Mumbai route. Just let us know your itinerary, and we’ll arrange for a convenient pickup and drop-off at your desired locations.',
    },
    {
        id: 7,
        question: 'Is customer support available for my Pune to Mumbai Urbania booking?',
        answer: 'Yes, Samarth Travels provides 24/7 customer support for all bookings, including the Pune to Mumbai Urbania trip. Whether you need assistance before, during, or after your journey, we are here to help.',
    },
];

const testimonials = [
    {
        name: 'Mr. Rohan Shetty',
        role: 'Business Owner',
        text: 'We rented a 17-seater Urbania from Pune to Mumbai for an important business trip. The van was comfortable, the driver was experienced, and the ride was very smooth. We will definitely book again for future corporate events.',
        image: '/img/testimonial/testi_urbania_rohan.jpg',
    },
    {
        name: 'Mrs. Priya Mehta',
        role: 'Family Trip Organizer',
        text: 'Booked a 13-seater Force Urbania for a family trip from Pune to Mumbai. The van was clean, well-maintained, and spacious. Our driver was courteous, and the entire trip was enjoyable. Highly recommend Samarth Travels!',
        image: '/img/testimonial/testi_urbania_priya.jpg',
    },
];






























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Urbania On Rent",
  "image": "https://samarthtravels.com/assets/images/pune-to-mumbai-urbania-on-rent.jpg",
  "description": "Rent a luxury Urbania vehicle for your Pune to Mumbai trip, including airport transfers. Affordable and comfortable rental options for family trips, corporate travel, group tours, and more. Available for both 13-seater and 17-seater Urbania buses.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "22000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/pune-to-mumbai-urbania-on-rent"
  }
};



    return (
        <div>



<Helmet>
  <title>Pune to Mumbai Urbania On Rent | Affordable & Luxury Bus Hire | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a luxury Urbania vehicle for your Pune to Mumbai trip, including airport transfers. Affordable and comfortable rental options for family trips, corporate travel, group tours, and more. Available for both 13-seater and 17-seater Urbania buses." 
  />
  <meta 
    name="keywords" 
    content="Urbania Bus On Rent in Mumbai Airport, Pune to Mumbai Airport Urbania on Rent, Mumbai Airport to Pune Urbania on Rent, FORCE URBANIA ON RENT IN MUMBAI, Luxury Force Urbania on Rent in Pune, 13 seater urbania on rent in pimpri chinchwad, 17 seater urbania on rent in pimpri chinchwad, 13 seater urbania on rent in Pune, 17 seater urbania on rent in Pune, urbania bus on rent for corporate employees, Pune to Mumbai Urbania bus On Rent, Force Urbania Luxury Mini Bus On Rent, force Urbania 17 Seater for Rent, Force Urbania for Rent Near Me, Force Urbania Luxury Mini Bus on Rent in Pun, pune to mumbai airport urbania Bus On Rent, urbania on rent in pimpri chinchwad" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/45.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaiurbaniaonrent;